export const blockIconsCommunicationChat = (
	<span className='material-symbols-outlined'>chat</span>
);
